import { ReactComponent as EditIcon } from '../../assets/images/icons/mevo/edit.svg';
import { ReactComponent as TrashIcon } from '../../assets/images/icons/mevo/trash-outlined.svg';
import { useIsMobile } from '../../helpers/useIsMobile';
import { Formula } from '../../interfaces/formula';
import { ActionIconButton } from '../ActionIconButton';
import { Box } from '../UI-CHAKRA/Box';
import { Flex } from '../UI-CHAKRA/Flex';
import { Grid as ChakraGrid } from '../UI-CHAKRA/Grid';
import { GridItem } from '../UI-CHAKRA/GridItem';
import { Text } from '../UI-CHAKRA/Text';

interface FormulaCardProps {
  formula: Formula;
  index: number;
  doctorId: number;
  onEditFormula(formula: Formula): void;
  handleDeleteFormula(formulaId: number): void;
}

export default function FormulaCard({
  formula,
  index,
  doctorId,
  onEditFormula,
  handleDeleteFormula,
}: FormulaCardProps) {
  const isMobile = useIsMobile();

  // Get structured composition
  const structuredComposition = formula.structuredComposition;

  return (
    <Box>
      <Box
        margin={'16px 0'}
        padding={'14px 16px'}
        position={'relative'}
        borderRadius={'10px'}
        bgColor={'white'}
        overflow={'hidden'}
        boxShadow={'3px 3px 10px rgba(52, 58, 64, 0.10)'}
      >
        <Box
          width={'fit-content'}
          marginBottom={'10px'}
          marginTop={'10px'}
          borderRadius={'48px'}
          backgroundColor={'#E9ECEE'}
          padding={'4px 12px'}
        >
          <Text fontWeight={700} color={'#545C62'} textAlign={'center'} fontSize={'12px'}>
            Manipulado
          </Text>
        </Box>
        <ChakraGrid width={'100%'} templateColumns="repeat(24, 1fr)">
          <GridItem justifyContent={'center'} colSpan={{ base: 2, md: 1 }}>
            <Text fontWeight={700} color={'#868E96'} textAlign={'center'} fontSize={'14px'}>
              {index + 1}
            </Text>
          </GridItem>

          <GridItem colSpan={{ base: 16, md: 18 }}>
            <Box>
              <Text fontWeight={600} fontSize={'14px'} textTransform={'initial'}>
                {formula.formulaName}
              </Text>
            </Box>
            {structuredComposition && structuredComposition.trim() !== '' && (
              <Box mt="4px">
                <Text
                  color={'#868E96'}
                  fontSize={'12px'}
                  fontWeight={400}
                  whiteSpace={'break-spaces'}
                  fontFamily="monospace"
                >
                  {structuredComposition}
                </Text>
              </Box>
            )}
            <Box mt="4px">
              <Text color={'#868E96'} fontSize={'14px'} fontWeight={700} whiteSpace={'break-spaces'}>
                {formula.posology}
              </Text>
            </Box>
          </GridItem>

          <GridItem
            colSpan={{ base: 6, md: 5 }}
            display={{ base: 'none', md: 'flex' }}
            justifyContent={'flex-end'}
            alignItems={'center'}
            gap={'10px'}
          >
            <ActionIconButton
              onClick={() => onEditFormula(formula)}
              iconColor={'gray.main'}
              iconHoverColor={'gray.dark'}
              Icon={<EditIcon />}
              role={'edit'}
              text="editar"
              width={isMobile ? 'auto' : 'auto'}
            />
            <ActionIconButton
              dataCy="removeMedicine"
              onClick={() => handleDeleteFormula(formula.id)}
              iconColor={'gray.main'}
              iconHoverColor={'error.main'}
              Icon={<TrashIcon />}
              role={'delete'}
              text={isMobile ? 'Excluir' : ''}
              width={isMobile ? 'auto' : 'auto'}
            />
          </GridItem>
        </ChakraGrid>
        <Flex display={{ base: 'flex', md: 'none' }} width={'100%'} gap={'10px'} marginTop={'16px'} paddingTop={'16px'}>
          <ActionIconButton
            onClick={() => onEditFormula(formula)}
            iconColor={'gray.main'}
            iconHoverColor={'gray.dark'}
            Icon={<EditIcon />}
            role={'edit'}
            text="Editar"
            width={'100%'}
          />
          <ActionIconButton
            dataCy="removeMedicine"
            onClick={() => handleDeleteFormula(formula.id)}
            iconColor={'gray.main'}
            iconHoverColor={'error.main'}
            Icon={<TrashIcon />}
            role={'delete'}
            text="Excluir"
            width={'100%'}
          />
        </Flex>
      </Box>
    </Box>
  );
}
